let alertTimeout

function showAlert(message, type = 'success', duration = 3000) {
  const alert = document.getElementById('alert-notification')
  const alertText = document.getElementById('alert-text')

  if (alertTimeout) {
    clearTimeout(alertTimeout)
  }

  alertText.textContent = message
  alert.classList.remove('success', 'error', 'warning')
  alert.classList.add(type)
  alert.classList.add('show')

  if (duration > 0) {
    alertTimeout = setTimeout(() => {
      closeAlert()
    }, duration)
  }
}

function closeAlert() {
  const alert = document.getElementById('alert-notification')
  alert.classList.remove('show')

  if (alertTimeout) {
    clearTimeout(alertTimeout)
    alertTimeout = null
  }
}

// Função global para mostrar alertas (usada pelo carrinho)
window.mostrarAlerta = function (message, type = 'success') {
  showAlert(message, type)
}

document.addEventListener('DOMContentLoaded', () => {
  // Atualizar contador do carrinho quando a página carregar
  setTimeout(() => {
    if (window.atualizarContadorCarrinho) {
      window.atualizarContadorCarrinho()
    }
  }, 500)

  // Busca do nav
  const buscaInput = document.querySelector('nav .busca input')
  const resultadosBusca = document.querySelector('nav .busca .resultados-busca')

  if (buscaInput && resultadosBusca) {
    let timeoutBusca
    buscaInput.addEventListener('input', function () {
      const termo = this.value.trim()
      clearTimeout(timeoutBusca)
      if (termo.length < 1) {
        resultadosBusca.style.display = 'none'
        resultadosBusca.innerHTML = ''
        return
      }
      // Pequeno delay para evitar requisições em excesso
      timeoutBusca = setTimeout(() => {
        resultadosBusca.innerHTML = '<div class="resultado-item buscando"><span class="loading"></span></div>'
        resultadosBusca.style.display = 'flex'
        fetch(`/search/suggest.json?q=${encodeURIComponent(termo)}&resources[type]=product&resources[limit]=5`)
          .then((res) => res.json())
          .then((data) => {
            const produtos = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : []
            if (produtos.length === 0) {
              resultadosBusca.innerHTML = '<div class="sem-resultado">Nenhum produto encontrado.</div>'
              return
            }
            resultadosBusca.innerHTML = produtos
              .map(
                (produto) => `
              <a href="${produto.url}" class="resultado-item">
                <div class="foto" style="background-image: url('${produto.image || '/assets/banner-capa.png'}')"></div>
                <span>${produto.title}</span>
              </a>
            `
              )
              .join('')
          })
          .catch(() => {
            resultadosBusca.innerHTML = '<div class="sem-resultado">Erro ao buscar produtos.</div>'
          })
      }, 200)
    })
    // Esconde o balão ao clicar fora
    document.addEventListener('click', function (e) {
      if (!buscaInput.contains(e.target) && !resultadosBusca.contains(e.target)) {
        resultadosBusca.style.display = 'none'
      }
    })
    // Mostra o balão ao focar se já tem texto
    buscaInput.addEventListener('focus', function () {
      if (this.value.trim().length > 0 && resultadosBusca.innerHTML) {
        resultadosBusca.style.display = 'flex'
      }
    })
  }
})
